<div class="container-fluid section pt-3 pb-2 pr-0 d-flex flex-column">
    <span class="header mb-3">Signed up clients</span>
    <div *ngIf="bookings.length" class="signup-section">
        <div class="sub-section py-2 px-3 mb-2 mr-2" *ngFor="let booking of bookings; let i = index">
            <div class="d-flex flex-row">
                <img class="profile-img" *ngIf="booking.mumBooked[0]?.profileImage"
                    [src]="booking.mumBooked[0]?.profileImage">
                <img class="profile-img" *ngIf="booking.mumBooked[0]?.profileImage==undefined"
                    src="../../../../../../assets/Images/pro-pic.png">
                <div class="d-flex flex-column flex-grow-1">
                    <span class="title ml-3" *ngIf="booking.mumBooked.length">{{booking.mumBooked[0]?.name}}</span>
                    <span class="section-text ml-3" *ngIf="booking.mumBooked.length">Due on:
                        {{booking.mumBooked[0]?.dueDate | date:'EEE dd MMM'}}</span>
                </div>
                <div class="fas mt-3 collapsed" data-toggle="collapse" [attr.data-target]="'#collapse-si-' + i"></div>
            </div>
            <div [attr.id]="'collapse-si-' + i" class="collapse">
                <div class="horizontal-line my-2"></div>
                <div class="d-flex flex-row mt-3 mb-2">
                    <i class="far fa-clock icon"></i>
                    <span class="section-text ml-3">{{booking?.startDate | date:'EEE dd MMM'}} - {{booking?.endDate |
                        date:'EEE dd MMM'}}</span>
                </div>
                <div class="d-flex flex-row mb-2">
                    <i class="fas fa-phone icon phone"></i>
                    <span class="section-text ml-3"
                        *ngIf="booking.mumBooked.length">{{booking.mumBooked[0].user[0].userPhonenumber}}</span>
                </div>
                <div class="d-flex flex-row my-2">
                    <i class="fas fa-envelope icon"></i>
                    <span class="section-text ml-3"
                        *ngIf="booking.mumBooked.length">{{booking.mumBooked[0].user[0]?.userEmail}}</span>
                </div>
                <div class="d-flex flex-row my-2">
                    <i class="fas fa-map-marker-alt icon pl-1"></i>
                    <span class="section-text ml-3"
                        *ngIf="booking.mumBooked.length">{{booking.mumBooked[0]?.address}}</span>
                </div>
                <div class="d-flex flex-row justify-content-end mt-4 mb-2" (click)="viewDetail(booking)">
                    <span class="navigate-text mr-2">VIEW DETAILS</span>
                    <i class="fas fa-long-arrow-alt-right arrow-icon mr-1"></i>
                </div>
            </div>
        </div>
    </div>
    <div class="no-data" *ngIf="!bookings.length">
        <img class="align-self-center" src="../../../../../../assets/Images/NoDocuments.png" height="50" width="80"
            alt="No Signed Up Clients">
        <span>No signed up clients</span>
    </div>
</div>

<app-view-booking (refresh)="refreshData($event)"></app-view-booking>